import React from "react";
import { disciplines } from "../data/mock";
import { intro } from "../data/mock";

const Disciplines = () => {
  return (
    <section
      id="disciplines"
      className="px-6 md:px-10 max-w-[1400px] mx-auto py-20 md:py-28 border-t border-[#d8d5cc]"
    >
      {/* Intro copy */}
      <div className="grid grid-cols-12 gap-4 mb-16 md:mb-24">
        <div className="col-span-12 md:col-span-3">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64] sticky top-28">
            {intro.eyebrow}
          </p>
        </div>
        <div className="col-span-12 md:col-span-9">
          <h2 className="text-[26px] md:text-[42px] leading-[1.15] tracking-[-0.015em] text-[#0d0d0d] font-display font-normal max-w-4xl">
            {intro.headline.split("logo").map((part, i, arr) =>
              i < arr.length - 1 ? (
                <React.Fragment key={i}>
                  {part}
                  <span className="italic font-serif">logo</span>
                </React.Fragment>
              ) : (
                part
              )
            )}
          </h2>
          <div className="mt-8 md:mt-10 max-w-2xl space-y-4">
            {intro.paragraphs.map((p, i) => (
              <p key={i} className="text-[15px] md:text-base leading-[1.7] text-[#3a3a36]">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>

      {/* 3 disciplines */}
      <div className="grid grid-cols-1 md:grid-cols-3 border-t border-[#0d0d0d]">
        {disciplines.map((d, idx) => (
          <a
            key={d.id}
            href={`#${d.id}-work`}
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector("#work");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className={`group relative p-6 md:p-8 border-b border-[#d8d5cc] ${
              idx !== 2 ? "md:border-r border-[#d8d5cc]" : ""
            } hover:bg-[#0d0d0d] transition-colors duration-500`}
          >
            <div className="flex items-start justify-between mb-12 md:mb-16">
              <span className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64] group-hover:text-[#bdbdb5] transition-colors duration-500">
                {d.number}
              </span>
              <span className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64] group-hover:text-[#bdbdb5] transition-colors duration-500">
                View work →
              </span>
            </div>

            <h3 className="font-display text-[30px] md:text-[36px] leading-[1] tracking-[-0.02em] text-[#0d0d0d] group-hover:text-[#f5f3ee] transition-colors duration-500">
              {d.title}
            </h3>

            <p className="mt-4 italic font-serif text-[15px] text-[#3a3a36] group-hover:text-[#d1cfc8] transition-colors duration-500">
              {d.subtitle}
            </p>

            <p className="mt-6 text-[14px] leading-[1.7] text-[#6b6b64] group-hover:text-[#bdbdb5] transition-colors duration-500 max-w-sm">
              {d.description}
            </p>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Disciplines;
